import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { labelStyle } from './label-style';

// A stand-in product image with the label drawn on it the way the
// storefront's product box does, so a label can be checked before it's live.
@Component({
    selector: 'app-label-preview',
    imports: [CommonModule, MatIconModule],
    template: `
    <div class="relative overflow-hidden rounded-xl bg-gradient-to-br from-stone-200 via-stone-300 to-stone-400 shadow-inner"
      [ngClass]="size === 'lg' ? 'aspect-square w-full' : 'h-14 w-16'">
      <!-- paving joints, so it reads as a product photo -->
      <div class="absolute inset-0 opacity-40 bg-[linear-gradient(90deg,transparent_48%,rgba(255,255,255,.7)_48%,rgba(255,255,255,.7)_52%,transparent_52%),linear-gradient(transparent_48%,rgba(255,255,255,.7)_48%,rgba(255,255,255,.7)_52%,transparent_52%)]"
        [style.background-size]="size === 'lg' ? '50% 33.3%' : '50% 50%'"></div>
      @if (text) {
        @switch (style) {
          @case ('BESTSELLER') {
            <div [style.background-color]="bg || null" [style.color]="fg || null" class="absolute top-0 left-0 bg-[#3c8d40] text-white font-semibold" [ngClass]="size === 'lg' ? 'px-3 py-2 text-sm' : 'px-1 py-0.5 text-[6px] leading-none'">{{ text }}</div>
          }
          @case ('BLACK_FRIDAY') {
            <div [style.background-color]="bg || null" [style.color]="fg || null" class="absolute bottom-0 inset-x-0 bg-black text-[#fdd835] font-bold text-center truncate" [ngClass]="size === 'lg' ? 'py-1.5 text-xs' : 'py-0.5 text-[6px] leading-none'">{{ text }}</div>
          }
          @case ('SEALER') {
            <div [style.background-color]="bg || null" [style.color]="fg || null" class="absolute bottom-0 inset-x-0 bg-[#f59e0b] text-neutral-900 font-bold text-center truncate" [ngClass]="size === 'lg' ? 'py-1.5 text-xs' : 'py-0.5 text-[6px] leading-none'">{{ text }}</div>
          }
          @default {
            <div [style.background-color]="bg || null" [style.color]="fg || null" class="absolute bottom-0 inset-x-0 bg-[#fdd835] text-neutral-900 font-bold text-center truncate" [ngClass]="size === 'lg' ? 'py-1.5 text-xs' : 'py-0.5 text-[6px] leading-none'">{{ text }}</div>
          }
        }
      }
    </div>
  `
})
export class LabelPreviewComponent {
  @Input() title = '';
  @Input() text = '';
  @Input() size: 'sm' | 'lg' = 'sm';
  // Chosen colours win over the built-in style, as on the website.
  @Input() bg: string | null = null;
  @Input() fg: string | null = null;

  get style() {
    return labelStyle(this.title || '', this.text || '');
  }
}
